import { registerComponentInterceptor } from '../componentInterceptor';
import { default as React } from 'react';
/**
 * Provides a custom layout for the TypeFragment on the Entity page.
 * @param _props  - Props for the jsx element
 */
export const CustomEntityLayoutType = (_props: any) => {
  return <></>;
};

/**
 * Register this component as an override for the default EntityLayoutTitle.
 */
registerComponentInterceptor({
  canIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return props?.children === 'system' ? true : false;
  },
  performIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return {
      element: <CustomEntityLayoutType props={props} />,
    };
  },
});
